<template>
    <Form
        ref="info"
        :rules="ruleValidate"
        :model="info"
        inline
        :label-width="100"
    >
        <Divider />
        <div>房间{{ index + 1 }}：{{ info.houseNum }}</div>
        <Row :gutter="20">
            <Col span="12">
                <FormItem label="建筑面积" prop="buildArea">
                    <input-number
                        v-model="info.buildArea"
                        placeholder
                        :min="0"
                        @on-blur="buildAreaChange(info)"
                    >
                        <span slot="append">㎡</span>
                    </input-number>
                </FormItem>
            </Col>
            <Col span="12">
                <FormItem label="单价" prop="unitPrice">
                    <input-number
                        v-model="info.unitPrice"
                        placeholder
                        :min="0"
                        @on-blur="unitPriceChange(info)"
                    >
                        <span slot="append">元/㎡/月</span>
                    </input-number>
                </FormItem>
            </Col>
        </Row>
        <Row :gutter="20">
            <Col span="12">
                <FormItem label="租金" prop="rent">
                    <input-number
                        v-model="info.rent"
                        placeholder
                        :min="0"
                        @on-blur="rentChange(info)"
                    >
                        <span slot="append">元/月</span>
                    </input-number>
                </FormItem>
            </Col>
            <!-- 单价区间 -->
            <Col span="12">
                <FormItem label="单价区间" prop="rentInterval">
                    <rent-interval
                        :info="info"
                        @on-min-price-change="minPriceChange"
                    />
                </FormItem>
            </Col>
        </Row>
    </Form>
</template>

<script>
import {
    buildAreaChange,
    unitPriceChange,
    rentChange,
} from '@/views/common/u-rent'

import RentInterval from '_vc/fields/rent-interval'
export default {
    name: 'SplitRoom',
    components: { RentInterval },
    props: {
        info: {
            type: Object,
            default: {},
        },
        index: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            buildAreaChange: buildAreaChange,
            unitPriceChange: unitPriceChange,
            rentChange: rentChange,
        }
    },
    computed: {
        ruleValidate() {
            const validateUnitPrice = (rule, value, callback) => {
                if (this.info.unitPrice == 0) callback()

                if (this.info.unitPrice - this.info.minPrice >= 0) callback()

                callback(new Error('单价不得低于最小值'))
            }
            return {
                unitPrice: [{ validator: validateUnitPrice }],
            }
        },
    },
    methods: {
        // 最低价格更改，触发校验
        minPriceChange() {
            this.$refs.info.validate()
        },
    },
}
</script>

<style></style>
